<template>
  <span class="flowStatus" :class="`type${status}`">
    {{ statusName(status) }}
  </span>
</template>

<script>
export default {
  name: "FlowStatus",

  props: {
    status: {
      type: [Number, String],
      required: true,
      default: 2
    }
  },

  methods: {
    statusName(status) {
      status = Number(status);
      switch (status) {
        case 1:
          return "已通过";
        case 2:
          return "审批中";
        case 3:
          return "已撤回";
        case 8:
          return "终止";
        case 9:
          return "草稿";
        case 0:
          return "已驳回";
        default:
          return "";
      }
    }
  }
};
</script>

<style lang="less" rel="stylesheet/stylus" scoped>
.flowStatus {
  border-radius: 6px;
  text-align: center;
  padding: 4px 6px;
}

.type1,
.type4 {
  background: rgba(0, 182, 50, 0.24);
  color: #00b632;
}
.type2 {
  background: rgba(243, 124, 38, 0.15);
  color: #f37c26;
}
.type3 {
  background: #70737e;
  color: #fff;
}
.type5 {
  background: rgba(243, 124, 38, 0.15);
  color: #f37c26;
}
.type0 {
  background: rgba(236, 54, 42, 0.15);
  color: #ec3226;
}
.type8 {
  border: 1px solid #9746E8;
  background: rgba(151, 70, 232, 0.10);
  color: #9746E8;
}
.type9 {
  border-color: #70737e;
  border: solid 1px;
  padding-top: 2px;
  padding-bottom: 2px;
}</style>
